export default __webpack_public_path__ + "images/1299f5055e9d9312fbdf07e771da6440.svg";